
class gridActions {

	constructor(args)
		{
			this.usingTracker = false;
			this.currentUserData = JSON.parse(localStorage.getItem("userData"));
			this.whiteboardValues = this.currentUserData.whiteboardValues;
			this.onDemand = window['onDemand'];
			this.guestUser = window['guestUser'];
			this.electron = window['electron'];
			this.sep = '~@$';
			this.id = args['user_id'];
			this.useMediaPipe = parseInt(this.whiteboardValues.useMediaPipe);
			this.gridBoxes = [];
			this.defaultZone = {'x1': 337, 'x2': 943, 'x3': 180, 'x4': 1100, 'y1': 557.5, 'y2': 657.5, 'columns': 5, 'rows': 3};
			this.setGridZone(this.defaultZone['x1'], this.defaultZone['x2'], this.defaultZone['x3'], this.defaultZone['x4'], this.defaultZone['y1'], this.defaultZone['y2'], this.defaultZone['columns'], this.defaultZone['rows'], true);
		
			this.x1 = this.defaultZone['x1'];
			this.x2 = this.defaultZone['x2'];
			this.x3 = this.defaultZone['x3'];
			this.x4 = this.defaultZone['x4'];
			this.y1 = this.defaultZone['y1'];
			this.y2 = this.defaultZone['y2'];
		}
		
	setGridZone(x1, x2, x3, x4, y1, y2, columns, rows, firstZone)
		{
			// x1 = top right, x2 = top left, x3 = bottom right, x4 = bottom left, y1 = top right and left, y2 = bottom right and left, columns = number of columns, rows = number of rows
			
			this.x1 = x1;
			this.x2 = x2;
			this.x3 = x3;
			this.x4 = x4;
			this.y1 = y1;
			this.y2 = y2;
			
			var gridColumns = columns;
			var gridRows = rows;
			var gridBoxWidthTop = ( x2 - x1 ) / gridColumns;
			var gridBoxWidthBottom = ( x4 - x3 ) / gridColumns;
			var gridBoxWidthMiddle = ( gridBoxWidthBottom - ( gridBoxWidthBottom - gridBoxWidthTop ) / 2 );
			var gridBoxHeight = ( y2 - y1 ) / gridRows;
			var gridStartX = x1;
			var gridBoxStartX = x1;
			var gridStartY = y1;
			var gridBoxWidth = gridBoxWidthTop;
			var gridBoxPosDiff = (x1 - x3) / (gridRows-1);
			var gridBoxWidthDiff = (gridBoxWidthBottom - gridBoxWidthTop) / (gridRows-1);
			this.gridBoxes = [];
			
			console.log('setGridZone gridBoxWidthTop', gridBoxWidthTop);
			console.log('setGridZone gridBoxWidthBottom', gridBoxWidthBottom);
			console.log('setGridZone gridBoxWidthMiddle', gridBoxWidthMiddle);
			console.log('setGridZone gridBoxHeight', gridBoxHeight);

			for ( var i = 0; i < gridRows; i++ )
				{
					for ( var b = 0; b < gridColumns; b++ )
						{
							this.gridBoxes.push({'x1': gridBoxStartX, 'y1': gridStartY, 'x2': gridBoxStartX+gridBoxWidth, 'y2': gridStartY+gridBoxHeight});
							gridBoxStartX += gridBoxWidth;
						}
					gridStartY += gridBoxHeight;
					gridBoxWidth += gridBoxWidthDiff;
					gridStartX -= gridBoxPosDiff;
					gridBoxStartX = gridStartX;
					console.log('setGridZone gridBoxWidth diff', gridBoxWidthDiff);
					console.log('setGridZone gridBoxWidth increased', gridBoxWidth);
					console.log('setGridZone gridStartY increased', gridStartY);
				}
			console.log(this.gridBoxes, 'gridBoxes');
			
			if ( this.guestUser && !firstZone )
				{
					let gridZoneObj = {'x1': x1, 'x2': x2, 'x3': x3, 'x4': x4, 'y1': y1, 'y2': y2, 'columns': columns, 'rows': rows};
					this.whiteboard.splitRTMSend(this.currentUserData['sessionData']['hostEmail'], "updateGridZone"+this.sep+JSON.stringify(gridZoneObj));
				}
		}
	
	getGridZone(num)
		{
			if ( !this.gridBoxes || this.gridBoxes.length < 0 ) { return false; }
			return this.gridBoxes[num];
		}
}

export default gridActions;